import { useMutation, useQueryClient } from "@tanstack/react-query";
import { QrscanIcon, XCloseIcon } from "assests";
import { Button } from "components/UI/Button";
import UpgradeComponent from "components/UI/UpgradeComponent";
import useCustomToaster from "hooks/useCustomToaster";
import toast from "react-hot-toast";
import { createQRCode } from "services/order.services";

const CreateQRScan = ({ closeModal, handleCreateQRCode }) => {
  return (
    <div className={` bg-white max-h-[600px] max-w-[512px] lg:w-[512px] rounded-xl relative z-[2]`}>
      <div className="absolute right-[26px] top-[26px] cursor-pointer" onClick={closeModal}>
        <XCloseIcon fillColor={"var(--color-icon-fill-default)"} height={24} width={24} />
      </div>

      <div className={`flex flex-col px-6 pt-6`}>
        <div className="mr-4">
          <UpgradeComponent>
            <QrscanIcon fillColor="var(--color-icon-default-2)" width={24} height={24} />
          </UpgradeComponent>
        </div>

        <div className="flex flex-col gap-5 pt-4 pb-5">
          <div className={`flex flex-col gap-1`}>
            <h4 className="text-base lg:text-lg font-semibold text-global-title-3">
              QR Experience
            </h4>
            <p className="text-xs lg:text-sm  text-global-paragraph tracking-tight">
              Are you sure you want to enable the QR experience for this order?
            </p>
          </div>
        </div>
      </div>

      <div
        className={`flex justify-center lg:justify-end flex-col lg:flex-row gap-3 pt-8 pb-6 px-6`}
      >
        <Button
          variant="secondary"
          className="px-4 py-2.5 w-full  h-11 text-sm md:text-base font-semibold"
          onClick={closeModal}
        >
          Cancel
        </Button>

        <Button
          variant="primary"
          className={`px-4 py-2.5 w-full gap-1.5  h-11 custom-primary-shadow text-white text-sm md:text-base font-semibold whitespace-nowrap`}
          onClick={handleCreateQRCode}
        >
          Create QR
        </Button>
      </div>
    </div>
  );
};

export default CreateQRScan;
